<template>
  <div class="procedure-container" @click.stop>
    <h1 class="title">{{ t('買取手順') }}</h1>
    <div class="step">
      <h3 class="step-title step1">Step1</h3>
      <p>{{ t('弊社へ査定依頼品の発送 & 買取申込フォームの送信') }}</p>
    </div>
    <div class="step">
      <h3 class="step-title step2">Step2</h3>
      <p>{{ t('メールにて査定結果の送信(到着後2営業日以内)') }}</p>
    </div>
    <div class="step">
      <h3 class="step-title step3">Step3</h3>
      <p>{{ t('お振込(査定結果へのご同意後2営業日以内)') }}</p>
    </div>
    <h1 class="title">{{ t('発送先') }}</h1>
      <p class="address">{{ t('〒330-0854 埼玉県さいたま市大宮区桜木町1丁目195‑1 大宮ソラミチKOZ4階') }}</p>
    <h1 class="title">{{ t('ご留意事項') }}</h1>
    <ul class="warning-list">
      <li>{{ t('1）買取表に掲載しているカードのみ買取可能です。') }}</li>
      <li>{{ t('2）身分証は「運転免許証」「パスポート」「マイナンバー」のいずれかでお願いいたします。') }}</li>
      <li>{{ t('3）100枚までの発送、同名同種のカードは5枚まででお願いいたします。') }}</li>
      <li>{{ t('4）偽物・状態が著しく悪いカード・買取表に掲載のないカードは査定不可となります。') }}</li>
      <li>{{ t('5）返送をご希望の場合は、着払いにてご返送いたします。') }}</li>
      <li>{{ t('6）査定額は、到着時の価格となります。発送時にご確認いただいた価格と異なってしまう場合がございます。') }}</li>
    </ul>
    <div class="button-group">
      <button class="cancel-button" @click="handleCancel">{{ t('キャンセル') }}</button>
      <BuyButton
        :class="{ disabled: !isLoggedIn }"
        class="purchase-btn"
        :text="t('申し込みへ')"
        :isArrow="false"
        :disabled="!isLoggedIn"
        @handleSquareBtnClick="handleApplication"
      />
    </div>
  </div>
</template>

<script>
import BuyButton from '@/components/atoms/BuyButton.vue';
import t from '@/plugins/i18n';

export default {
  name: 'PurchaseProcedure',
  mixins: [t],
  components: {
    BuyButton,
  },
  props: {
    isLoggedIn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCancel() {
      this.$emit('handleCancel');
    },
    handleApplication() {
      if (this.isLoggedIn) {
        this.$emit('handleApplication');
      } else {
        this.$emit('handleCancel');
        this.$nextTick(() => {
          this.$store.dispatch('user/setShowLoginPage', true);
        });
      }
    },
  },
};

</script>

<style lang="scss" scoped>
.procedure-container {
  overflow: auto;
  text-align: center;
  padding: 20px 0;
  color: $gray2;
  .title {
    font-weight: bold;
    color: #d35400;
    text-align: left;
  }

  .step {
    text-align: left;
    margin-top: 10px;
    .step-title {
      color: #072e80;
      font-size: 18px;
      font-weight: bold;
      padding-left: 20px;
    }
    p {
      text-align: left;
      font-weight: bold;
      padding-left: 40px;
      @media screen and (max-width: $tabletWidth) {
        font-size: 14px;
      }
    }
  }
  .address {
    text-align: left;
    font-weight: bold;
    font-size: 15px;
    padding-left: 15px;
    @media screen and (max-width: $tabletWidth) {
      font-size:13px
    }
  }
  .warning-list {
    padding-left: 15px;
    text-align: left;
    font-weight: bold;
    font-size: 15px;
    /* line-height: 1.5; */
    li{
      list-style-type: none;
    }
    @media screen and (max-width: $tabletWidth) {
        font-size:13px
      }
  }
  .button-group {
    display: flex;
    margin: 0 auto;
    justify-content: space-around;
    margin-top: 20px;
    left: 50%;
    width: calc(100% - 40px);
    gap: 10px;
    button {
      width: 45%;
      padding: 10px 60px;
      border: none;
      cursor: pointer;
      border-radius: 10px;
      font-size: 16px;
      font-weight: bold;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.4);
      @media screen and (max-width: $tabletWidth) {
        padding: 10px 25px;
      }
    }
    .cancel-button {
      color: #a1a2a2;
    }
  }
}
</style>
